import React, {useEffect, useMemo} from "react";
import {debounceTime, Subject, switchMap, tap} from "rxjs";
import {CircularProgress, TextField} from "@mui/material";
import {PageResponse} from "../../../services/ApiTypes";
import {Option, OptionPage} from "./ApiDropdownTypes";

type Props = {
    options: OptionPage
    getOptions: (search: string) => Promise<PageResponse<Option>>
    setOptions: (options: OptionPage) => void
    onSelectAllResults?: () => void
}

export const ApiDropdownSearchComponent: React.FC<Props> = ({options, getOptions, setOptions, onSelectAllResults}) => {
    const [inputValue, setInputValue] = React.useState(options?.search ?? '');
    const [loadingSearch, setLoadingSearch] = React.useState(false);

    const pipe = useMemo(() => new Subject<string>(), [])

    useEffect(() => {
        const sub = pipe.pipe(
            tap(() => setLoadingSearch(true)),
            // throttleTime(500),
            debounceTime(500),
            switchMap(search => getOptions(search).then(resp => ([resp, search] as const))),
        ).subscribe({
            next: ([resp, search]) => {
                setOptions({
                    search: search,
                    page: 1,
                    window: resp.results,
                    total: resp.count
                });
                setLoadingSearch(false);
            },
            error: err => {
                console.error(err);
                setLoadingSearch(false);
            },
        });
        return () => {
            sub.unsubscribe();
        };
        // eslint-disable-next-line
    }, []);


    return <TextField
        variant="standard"
        fullWidth
        autoFocus
        label="Search"
        value={inputValue}
        onChange={e => {
            setInputValue(e.target.value);
            pipe.next(e.target.value);
        }}
        InputProps={{
            endAdornment: loadingSearch ? <CircularProgress size={24}/> : null
        }}
        onKeyDown={event => {
            if (event.key === 'Enter' && !loadingSearch) {
                if (onSelectAllResults)
                    onSelectAllResults()
            }
        }}
    />
}
